// src/socketClient.js
import { io } from "socket.io-client";
import { getSocketUrlWeb } from "./Config";

const isLocalhost = window.location.hostname === "localhost";

const socket = io(getSocketUrlWeb(), {
  path: isLocalhost ? "/socket.io" : "/backend/socket.io",
  transports: ["polling", "websocket"],
  reconnection: true,
  rejectUnauthorized: false,
});

socket.on("connect", () => {
  console.log("Connected to live Socket.IO");
  socket.emit("join_plan", "Basic");
});

socket.on("connect_error", (err) => {
  console.log("Connect Error:", err.message);
});

socket.on("disconnect", (reason) => {
  console.log("Disconnected:", reason);
});

export default socket;